/* eslint-disable react/jsx-no-bind */
/* @flow */
import * as React from 'react';
import { translate, type TFunction } from 'react-i18next';
import noop from 'lodash/noop';
import theme from './PasswordField.scss';
import { EnhancedField } from 'common/components/core/form/Field';
import { PopoverPlaceEnum } from 'common/components/core/popover/popOverFactory';
import { ButtonTypes, Button } from 'common/components/core/button';
import { DomInputTypeEnum } from 'common/enums/DomEnums';
import { SizeEnum } from 'common/enums/UIEnums';

type OwnProps = {
    value: string,
    onChange: (value: string) => void,
    errorMessage?: ?string,
    label: string,
    autocomplete: string,
    autoFocus?: boolean,
    testId?: string
};

type Props = {
    ...OwnProps,
    t: TFunction
};

const PasswordField = ({
    value,
    onChange,
    label,
    t,
    errorMessage,
    autoFocus,
    autocomplete,
    testId
}: Props) => {
    const [show, setShow] = React.useState(false);

    const ToggleIcon = ({ icon, onClick }) => (
        <Button
            icon={icon}
            className={theme.passwordIcon}
            buttonType={ButtonTypes.Icon}
            size={SizeEnum.Small}
            onClick={onClick}
        />
    );

    return (
        <div className={theme.passwordEntity}>
            <div className={theme.entityName}>{label}</div>
            <EnhancedField
                element={'input'}
                type={show ? DomInputTypeEnum.Text : DomInputTypeEnum.Password}
                isVisible
                autoFocus={autoFocus}
                autocomplete={autocomplete}
                showRequired
                isPopOverOpen
                theme={theme}
                place={PopoverPlaceEnum.Right}
                defaultValue={null}
                placeholder={t('required')}
                rightIcon={
                    <ToggleIcon
                        icon={show ? 'eye-hide' : 'eye'}
                        onClick={() => setShow(!show)}
                    />
                }
                error={errorMessage}
                value={value}
                onChange={onChange}
                onCopy={noop}
                testId={testId}
            />
        </div>
    );
};

export default (translate('settings')(
    PasswordField
): React.AbstractComponent<OwnProps>);
